// Corporate Color Theme Configuration
// Professional, enterprise-grade color palette for B2B SaaS

export const corporateTheme = {
  // Primary Brand Colors
  primary: {
    main: 'slate-700',
    light: 'slate-100',
    dark: 'slate-900',
    bg: 'bg-slate-700',
    text: 'text-slate-700',
    hover: 'hover:bg-slate-800',
    border: 'border-slate-300',
  },

  // Success State
  success: {
    main: 'emerald-700',
    light: 'emerald-50',
    bg: 'bg-emerald-700',
    text: 'text-emerald-700',
    lightBg: 'bg-emerald-50',
    lightText: 'text-emerald-700',
    border: 'border-emerald-200',
  },

  // Warning State
  warning: {
    main: 'amber-600',
    light: 'amber-50',
    bg: 'bg-amber-600',
    text: 'text-amber-700',
    lightBg: 'bg-amber-50',
    lightText: 'text-amber-800',
    border: 'border-amber-200',
  },

  // Error State
  error: {
    main: 'red-700',
    light: 'red-50',
    bg: 'bg-red-700',
    text: 'text-red-700',
    lightBg: 'bg-red-50',
    lightText: 'text-red-700',
    border: 'border-red-200',
  },

  // Info State
  info: {
    main: 'blue-700',
    light: 'blue-50',
    bg: 'bg-blue-700',
    text: 'text-blue-700',
    lightBg: 'bg-blue-50',
    lightText: 'text-blue-800',
    border: 'border-blue-200',
  },

  // Call Type Colors
  callTypes: {
    discovery: {
      bg: 'bg-blue-50',
      text: 'text-blue-800',
      badge: 'bg-blue-100 text-blue-800 border-blue-200',
    },
    demo: {
      bg: 'bg-indigo-50',
      text: 'text-indigo-800',
      badge: 'bg-indigo-100 text-indigo-800 border-indigo-200',
    },
    followup: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-800',
      badge: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    },
  },

  // Status Colors
  status: {
    scheduled: {
      bg: 'bg-blue-50',
      text: 'text-blue-700',
      badge: 'bg-blue-100 text-blue-800 border-blue-200',
    },
    completed: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-700',
      badge: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    },
    overdue: {
      bg: 'bg-red-50',
      text: 'text-red-700',
      badge: 'bg-red-100 text-red-800 border-red-200',
    },
    cancelled: {
      bg: 'bg-gray-50',
      text: 'text-gray-600',
      badge: 'bg-gray-100 text-gray-700 border-gray-200',
    },
  },
};

export const CALL_TYPE_CONFIG = {
  CALL1: {
    label: 'Alignment Call #1',
    color: corporateTheme.callTypes.discovery.badge,
    icon: '🔍',
  },
  CALL2: {
    label: 'Confirmation Call #2',
    color: corporateTheme.callTypes.demo.badge,
    icon: '🎯',
  },
  CALL3: {
    label: 'Follow-up Call',
    color: corporateTheme.callTypes.followup.badge,
    icon: '📞',
  },
};

export const STATUS_CONFIG = {
  OPEN: {
    label: 'Scheduled',
    color: corporateTheme.status.scheduled.badge,
  },
  DONE: {
    label: 'Completed',
    color: corporateTheme.status.completed.badge,
  },
  SKIPPED: {
    label: 'Cancelled',
    color: corporateTheme.status.cancelled.badge,
  },
};

export default corporateTheme;
